import FindMerchantScreen from '../screens/FindMerchant'
import { NextPage } from 'next'

export const FindMerchant: NextPage = () => {

  return (
    <>
      <FindMerchantScreen />
    </>
  )
}
